/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getNeighborhoodsNewSignupsPauseStatus} from '../api'

 export const useQueryGetNeighborhoodsNewSignupsPauseStatus = createReactQueryHook('getNeighborhoodsNewSignupsPauseStatus', getNeighborhoodsNewSignupsPauseStatus)
